import { GenericError, Store } from "@tendercuts/models";

export interface StoreState {
  loading: boolean;
  configLoading: boolean;
  errorMsg: GenericError;
  availableStores: Store[];
  store: Store;
}

export const storeInitialState: StoreState = {
  loading: false,
  configLoading: false,
  errorMsg: null,
  availableStores: [],
  store: null,
};

export function storeTestState(): StoreState {
  return {
    loading: false,
    configLoading: false,
    errorMsg: null,
    availableStores: [],
    store: null,
  };
}
